import React, { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

interface Props {
  forumUuid: string;
  darkMode: boolean;
}

const ActivityHeatmap: React.FC<Props> = ({ forumUuid, darkMode }) => {
  const [cells, setCells] = useState<number[]>([]);

  useEffect(() => {
    (async () => {
      const { data } = await supabase
        .from('forum_stat_snapshots')
        .select('members_count, recorded_at')
        .eq('forum_id', forumUuid)
        .order('recorded_at', { ascending: true })
        .limit(52);
      if (!data?.length) {
        setCells([]);
        return;
      }
      const vals = data.map((d) => d.members_count || 0);
      const max = Math.max(...vals, 1);
      setCells(vals.map((v) => Math.round((v / max) * 4)));
    })();
  }, [forumUuid]);

  if (!cells.length) return null;

  const colors = ['bg-gray-200 dark:bg-gray-800', 'bg-green-200 dark:bg-green-900', 'bg-green-400 dark:bg-green-700', 'bg-green-600 dark:bg-green-500', 'bg-green-800 dark:bg-green-400'];

  return (
    <div>
      <h4 className={`text-sm font-medium mb-2 ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
        Üye aktivite ısı haritası
      </h4>
      <div className="flex flex-wrap gap-1">
        {cells.map((level, i) => (
          <div key={i} className={`w-3 h-3 rounded-sm ${colors[level]}`} title={`Kayıt ${i + 1}`} />
        ))}
      </div>
    </div>
  );
};

export default ActivityHeatmap;
